module.exports = __webpack_public_path__ + "static/media/HyruanOnePoster.6def7e1f.jpg";